import { v4 as uuidv4 } from 'uuid'

import speakersData2024 from 'resources/speakers/2024'

const MariaEncinar = speakersData2024.find(item => item.name === 'María Encinar')
const ChristineArmiyants = speakersData2024.find(item => item.name === 'Kristiné Armiyants')
const ViktorVedmich = speakersData2024.find(item => item.name === 'Viktor Vedmich')
const DenisAstahov = speakersData2024.find(item => item.name === 'Denis Astahov')
const NikitaFedkin = speakersData2024.find(item => item.name === 'Nikita Fedkin')
const HovoMikayelyan = speakersData2024.find(item => item.name === 'Hovhannes Mikayelyan')
const DazikAkbarov = speakersData2024.find(item => item.name === 'Dazik Akbarov')
const SaidAgitaev = speakersData2024.find(item => item.name === 'Said Akhmed Agitaev')
const Tigran = speakersData2024.find(item => item.name === 'Tigran Hunanyan')
const Alexey = speakersData2024.find(item => item.name === 'Alexey Eremin')
const PetrKalmukhyan = speakersData2024.find(item => item.name === 'Petr Kalmukhyan')
const AntonEremin = speakersData2024.find(item => item.name === 'Anton Eremin')
const SamMosleh = speakersData2024.find(item => item.name === 'Sam Mosleh')
const Mikayel = speakersData2024.find(item => item.name === 'Mikayel Ghazaryan')
const Vahan = speakersData2024.find(item => item.name === 'Vahan Terzibashian')
const Irine = speakersData2024.find(item => item.name === 'Irine Kokilashvili')
const Gagik = speakersData2024.find(item => item.name === 'Gagik Khalafyan')

const agendaData2024 = [
  {
    id: uuidv4(),
    date: '09:00 AM',
    title: 'Registration open',
    language: null,
    hall: null,
    info: null,
    type: 'start',
    speakersList: null,
  },
  {
    id: uuidv4(),
    date: '09:45 AM 10:10 AM',
    title: 'Opening ceremony',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: null,
  },
  {
    id: uuidv4(),
    date: '10:10 AM 10:40 AM',
    title: 'The Power of Many + Quiz',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [MariaEncinar, ChristineArmiyants],
  },
  {
    id: uuidv4(),
    date: '10:40 AM 11:20 AM',
    title: 'Kubernetes Security: Tackling Attacks & Best Practices',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [ViktorVedmich],
  },
  {
    id: uuidv4(),
    date: '11:20 AM 12:20 PM',
    title: 'AWS Security',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [DenisAstahov],
  },
  {
    id: uuidv4(),
    date: '12:20 PM 13:20 PM',
    title: 'MLOps practices',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [NikitaFedkin],
  },
  {
    id: uuidv4(),
    date: '13:20 PM 14:00 PM',
    title: 'Lunch',
    language: 'En',
    hall: null,
    info: null,
    type: 'start',
    speakersList: null,
  },

  // Track 1

  {
    id: uuidv4(),
    date: '14:00 PM 14:45 PM',
    title: 'Real-World Cost Optimization Solutions on AWS',
    language: 'En',
    hall: 'Classroom 213w',
    info: null,
    type: 'trackOne',
    speakersList: [HovoMikayelyan],
  },

  {
    id: uuidv4(),
    date: '14:45 PM 15:30 PM',
    title: 'Build Context-aware Chatbot with Amazon Bedrock',
    language: 'En',
    hall: 'Classroom 213w',
    info: null,
    type: 'trackOne',
    speakersList: [DazikAkbarov, SaidAgitaev],
  },

  {
    id: uuidv4(),
    date: '15:30 PM 16:15 PM',
    title: 'Optimizing Financial Services with Hybrid Cloud Solutions',
    language: 'En',
    hall: 'Classroom 213w',
    info: null,
    type: 'trackOne',
    speakersList: [Tigran],
  },

  {
    id: uuidv4(),
    date: '16:15 PM 17:00 PM',
    title: 'Athena Best Practices and Beyond: The story of S3 bucket cost',
    language: 'En',
    hall: 'Classroom 213w',
    info: null,
    type: 'trackOne',
    speakersList: [Alexey],
  },

  // Track 2

  {
    id: uuidv4(),
    date: '14:00 PM 14:45 PM',
    title: 'AWS Transit Gateway',
    language: 'En',
    hall: 'Classroom 214w',
    info: null,
    type: 'trackTwo',
    speakersList: [PetrKalmukhyan],
  },

  {
    id: uuidv4(),
    date: '14:45 PM 15:30 PM',
    title: 'Just-in-Time Access with AWS IAM Identity Center',
    language: 'En',
    hall: 'Classroom 214w',
    info: null,
    type: 'trackTwo',
    speakersList: [AntonEremin],
  },

  {
    id: uuidv4(),
    date: '15:30 PM 16:15 PM',
    title: 'Data Modeling in DynamoDB',
    language: 'En',
    hall: 'Classroom 214w',
    info: null,
    type: 'trackTwo',
    speakersList: [SamMosleh],
  },

  {
    id: uuidv4(),
    date: '16:15 PM 17:00 PM',
    title: 'EC2 instance deployment unification across AWS Organization',
    language: 'En',
    hall: 'Classroom 214w',
    info: null,
    type: 'trackTwo',
    speakersList: [Mikayel],
  },

  // Workshops

  {
    id: uuidv4(),
    date: '14:00 PM 15:00 PM',
    title: 'Building SaaS applications on Amazon EKS using GitOps',
    language: 'En',
    hall: 'Classroom 208e',
    info: null,
    type: 'workshops',
    speakersList: [Vahan],
  },

  {
    id: uuidv4(),
    date: '15:00 PM 16:00 PM',
    title: 'Startup Security: Techniques to Stay Secure while Building Quickly',
    language: 'En',
    hall: 'Classroom 208e',
    info: null,
    type: 'workshops',
    speakersList: [Irine],
  },

  {
    id: uuidv4(),
    date: '16:00 PM 17:00 PM',
    title: 'Amazon SageMaker MLOps: from idea to production in six steps',
    language: 'En',
    hall: 'Classroom 208e',
    info: null,
    type: 'workshops',
    speakersList: [Gagik],
  },

  // End

  {
    id: uuidv4(),
    date: '17:00 PM 17:30 PM',
    title: 'Closing ceremony, more fun, gifts and group photo',
    language: null,
    hall: 'Manoogian Hall',
    info: null,
    type: 'end',
    speakersList: null,
  },
]

export default agendaData2024
